import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import CampusMindWorkforcesImage from '../../assets/CampusMind Workforces.png';
const StartPage = () => {
  const navigate = useNavigate();
  const steps = [
    { title: 'AI Teaching Assistant', path: "/test" },
    { title: 'Manage\nTeaching Assisant', path: "/manage-vta" },
    { title: 'AI\nAgents', path: "/create-agent" },
    { title: 'Orchestration\nAgent', path: "/create-orchestration-agent" },
    { title: 'Accessibility\nAgent', path: "/accessibility-agent" },
    { title: 'IT Workforce', path: "/it-helpdesk-agent" },
    { title: 'Workday\nAssistant', path: "/workday-assistant" },
    { title: 'Recruiting\nWorkforce', path: "/recruiting-workforce" },
    { title: 'Explore Marketplace', path: "/explore-marketplace" },
    { title: 'Security and Architecture', path: "/security-and-data-protection" },
    { title: 'EDUCAUSE', path: "/educause" }
  ];

  const handleStepClick = (path) => {
    navigate(path);
  }

  return (
    <div className="min-h-screen bg-purple-50 pb-20">
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-8 sm:py-12 text-center">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
          CampusMind Lab
        </h2>

        <p className="text-base sm:text-lg md:text-xl text-gray-700 mb-8 sm:mb-12 leading-relaxed max-w-3xl mx-auto px-2">
          Ready to see how AI can reshape learning? In just 5 minutes, you'll test an AI assistant,
          create your own agent, and discover a marketplace of possibilities — no signup, no stress, all innovation.
        </p>

        <div className="mb-8 sm:mb-12">
          <img
            src={CampusMindWorkforcesImage}
            alt="CampusMind workforces illustration"
            className="mx-auto max-w-full rounded-lg shadow-md"
          />
        </div>

        <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4 sm:mb-6">
          AI Labs
        </h3>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-8 sm:mb-12">
          {steps.map((step, index) => (
            <div key={index} className="text-center bg-white rounded-lg p-4 sm:p-6 shadow-md cursor-pointer hover:shadow-xl transition-all duration-200 hover:scale-105" onClick={() => handleStepClick(step.path)}>
              <div className="text-xs sm:text-sm md:text-base font-semibold text-gray-800 whitespace-pre-line">
                {step.title}
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center px-4">
          <Link
            to="/test"
            className="bg-purple-700 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold text-base sm:text-lg hover:bg-purple-800 transition-all duration-200 flex items-center gap-2 shadow-lg hover:shadow-xl transform hover:scale-105 w-full sm:w-auto justify-center max-w-md"
            aria-label="Launch your AI lab"
          >
            Launch Your AI Lab
            <span className="text-lg sm:text-xl">&#9654;</span>
          </Link>
        </div>
      </main>
    </div>
  );
};

export default StartPage; 
